export default function selectGitHubOwnersAreLoading(state) {
  return state.integrations.thirdPartyData.github.installs.byOwnerId
}
